import { EMPTY_LIST } from '../../../constants/common'

export function getProfileLabelsWidgetItems(labels = EMPTY_LIST) {
  return labels.map(label => ({
    backgroundColor: label.color,
    id: label.id,
    text: label.name,
  }))
}
